import { render, staticRenderFns } from "./wai_search_iframe.vue?vue&type=template&id=08387a2e"
import script from "./wai_search_iframe.vue?vue&type=script&lang=js"
export * from "./wai_search_iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports